import styles from './Trukonf.module.css';
import trukonf from './../PartnersLogo/trueconf-logo.png';

const Trukonf = () => {
   return (
      <div className="container-lg">
         <div className="row justify-content-start m-5">
            <div className="col">
               <header className={styles.header}>
                  <h6>Главная--Партнеры--TrueConf</h6>
                  <h1>TrueConf</h1>
               </header>
            </div>
         </div>

            <hr />

         <div className="row justify-content-start">

               <div className="col-lg-4 col-sm-12 justify-content-center">
                  <img className={styles.body} src={trukonf} alt="actlogo" />
               </div>

                <div className="col-lg-8 col-sm-12 ">
                <div>
                  <h4>TrueConf — видеоконференции без границ</h4>
                  <p>Миссия TrueConf — обеспечить пользователей доступной безопасной видеосвязью и эффективными инструментами совместной работы. Общайтесь с коллегами и клиентами с любого устройства, где бы вы ни находились: в офисе, дома, в командировке или в пути.</p>
                  <p>TrueConf — крупнейший разработчик программных и аппаратных решений для видеоконференцсвязи и удаленной работы в России. TrueConf Server, наше флагманское решение для видеосвязи, может работать в закрытой сети и объединять до 1000 абонентов в одной конференции.</p>
                  <p>TrueConf позволяет объединить ПК, мобильные устройства, стационарные номера, переговорные комнаты и сторонние решения видеоконференцсвязи в рамках одной корпоративной сети. Интеграция занимает всего 15 минут. Видеосвязь TrueConf доступна на любом устройстве на базе Windows, macOS, Linux, iOS, Android и Android TV, а также в браузерах.</p>
                  <p>Мы реализовали тысячи успешных проектов для государственных, образовательных и финансовых учреждений, а также предприятий малого и среднего бизнеса. При этом число организаций, которые ежедневно используют бесплатную версию TrueConf Server, достигает десятков тысяч.</p>
                  <p>Широкая партнёрская сеть TrueConf состоит из более чем 1200 компаний-интеграторов по всему миру. Они успешно реализуют самые сложные ВКС-проекты и и обеспечивают для заказчиков новый уровень дистанционного общения во всех сферах - от государственных структур до телемедицины.</p>
                  <p>В 2017 году частью TrueConf стала компания Unitsolutions - интернет-магазин AV-оборудования и ведущий системный интегратор в России и СНГ. Наши специалисты готовы оказать полный комплекс услуг по подбору AV-оборудования, его внедрению в вашу переговорную, а также по настройке и интеграции с существующей ВКС-инфраструктурой.</p>
               </div>
                </div>
         </div>
      </div>
   )
}
export default Trukonf;